import typeOfOperand from "../base/typeOfOperand";

export default function shallowEquals(object1, object2) {
    let object1Type = typeOfOperand(object1);
    let object2Type = typeOfOperand(object2);

    if (object1Type !== "object") {
        return false;
    }

    if (object2Type !== "object") {
        return false;
    }

    if (object1 === object2) {
        return true;
    }

    let object1Keys = Object.keys(object1);
    let object2Keys = Object.keys(object2);
    let object1length = object1Keys.length;

    if (object2Keys.length !== object1length) {
        return false;
    }

    for (let i = 0; i < object1length; i++) {
        let key = object1Keys[i];

        if (
            object1.hasOwnProperty(key) !== object2.hasOwnProperty(key) ||
            object1[key] !== object2[key]
        ) {
            return false;
        }
    }

    return true;
}
